import { render, staticRenderFns } from "./VehicleInformation.vue?vue&type=template&id=604f4782&"
import script from "./VehicleInformation.vue?vue&type=script&lang=js&"
export * from "./VehicleInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports